/**
 * 옵션 타입별 핸들러를 생성하는 Factory
 */
import { UnifiedOptionHandler } from './UnifiedOptionHandler';
import { SeparatedOptionHandler } from './SeparatedOptionHandler';
import { IndependentOptionHandler } from './IndependentOptionHandler';
import { LinkedProductOptionHandler } from './LinkedProductOptionHandler';

/**
 * 옵션 타입 상수
 */
export const OPTION_TYPES = {
    UNIFIED: 'unified',           // 일체선택형 옵션
    SEPARATED: 'separated',       // 분리선택형 옵션
    INDEPENDENT: 'independent',   // 독립형 옵션
    LINKED_PRODUCT: 'linked_product' // 상품연동형 옵션
};

/**
 * 옵션 타입에 따라 적절한 핸들러를 생성
 * @param {string} optionType - 옵션 타입
 * @param {Object} config - 핸들러 설정
 * @returns {BaseOptionHandler} 옵션 핸들러 인스턴스
 */
export function createOptionHandler(optionType, config) {
    switch (optionType) {
        case OPTION_TYPES.UNIFIED:
            return new UnifiedOptionHandler(config);
        case OPTION_TYPES.SEPARATED:
            return new SeparatedOptionHandler(config);
        case OPTION_TYPES.INDEPENDENT:
            return new IndependentOptionHandler(config);
        case OPTION_TYPES.LINKED_PRODUCT:
            return new LinkedProductOptionHandler(config);
        default:
            // 기본값: 분리선택형 (기존 로직과 유사)
            console.warn(`Unknown option type: ${optionType}, using SeparatedOptionHandler as default`);
            return new SeparatedOptionHandler(config);
    }
}

/**
 * API 응답에서 옵션 타입을 추출
 * @param {Object} response - API 응답 데이터
 * @returns {string} 옵션 타입
 */
export function extractOptionType(response) {
    // TODO: 실제 API 응답 구조에 맞게 수정
    // 예시:
    // - response.optionType
    // - response.option_type
    // - response.options[0].type
    // - response.metadata.optionType
    
    const options = Array.isArray(response?.options) ? response.options : [];
    let optionType = null;
    let optionListType = null;

    for (const opt of options) {
        const typeRaw = opt?.option_type;
        const listTypeRaw = opt?.option_list_type;
        const type = typeof typeRaw === 'string' ? typeRaw.trim() : typeRaw;
        const listType = typeof listTypeRaw === 'string' ? listTypeRaw.trim() : listTypeRaw;
        if (type && listType) {
            optionType = type;
            optionListType = listType;
            break;
        }
    }
    
    // optionType과 optionListType을 조합하여 최종 옵션 타입 판단

    if (optionType === 'T' && optionListType === 'C') {
        return OPTION_TYPES.UNIFIED;
    }
    
    if (optionType === 'T' && optionListType === 'S') {
        return OPTION_TYPES.SEPARATED;
    }
    
    if (optionType === 'E' && optionListType === 'S') {
        return OPTION_TYPES.LINKED_PRODUCT;
    }
    
    if (optionType === 'F' && optionListType === 'S') {
        return OPTION_TYPES.INDEPENDENT;
    }
    
    // 기본값: 분리선택형
    return OPTION_TYPES.SEPARATED;
}

